export default class DownloadUtils {
	static saveFile(blob: any, fileName: string, fileType: string, withTimestamp: boolean) {
		let name = fileName + '.' + fileType;
		if (withTimestamp) {
			name = this.setFileName(fileName, fileType);
		}
		if (window.navigator.msSaveBlob) {
			// for IE browser
			setTimeout(() => {
				window.navigator.msSaveBlob(blob, name);
			}, 500);
		} else {
			const link = document.createElement('a');
			document.body.appendChild(link);
			link.href = window.URL.createObjectURL(blob);
			link.download = name;
			link.target = '_blank';
			link.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));
			window.URL.revokeObjectURL(link.href);
			link.remove();
		}
	}

	static setFileName(fileName: string, fileType: string): string {
		let TIMESTAMP = new Date().toISOString();
		TIMESTAMP = TIMESTAMP.substring(0, TIMESTAMP.indexOf('.'));
		return fileName + '_' + TIMESTAMP + '.' + fileType;
	}
}